import React from "react";
import {
  AccountBenefits,
  determineAccountBenefitsType,
} from "./AccountBenefits";
import { getQueryStringParams } from "@theatticusapp/atticus-shared-components";
import { Box, useMediaQuery, Theme } from "@mui/material";
import Page from "../../components/Page";
import { HostedAuth } from "./HostedAuth";

export const AuthScreen = (): JSX.Element => {
  const params = getQueryStringParams();
  const origin = params?.origin || undefined;
  const feature = params?.feature || undefined;

  const benefitsType = determineAccountBenefitsType({ origin, feature });

  const stackedLayout = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Page
      sx={{
        backgroundColor: "background.default",
        height: "100%",
        display: "flex",
      }}
      title="Atticus Authentication"
      noPad={true}
      flexChildren={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: stackedLayout ? "column" : "row",
          justifyContent: stackedLayout ? "flex-start" : "space-between",
          width: "100%",
          "& > div": {
            display: "flex",
          },
        }}
      >
        <Box
          className="Auth-Benefits"
          sx={{
            width: stackedLayout ? "100%" : `50%`,
            my: 0,
            py: stackedLayout ? 2 : 8,
            px: { xs: 1, sm: 4 },
            justifyContent: stackedLayout ? "center" : "flex-end",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 575,
              mt: {
                md: 7,
                sm: 0,
              },
            }}
          >
            <AccountBenefits benefit={benefitsType} />
          </Box>
        </Box>
        <Box
          className="Auth-Form"
          sx={{
            width: stackedLayout ? "100%" : `50%`,
            my: 0,
            py: stackedLayout ? 2 : 8,
            px: { xs: 1, sm: 4 },
            justifyContent: stackedLayout ? "center" : "flex-start",
            backgroundColor: "white",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 575,
            }}
          >
            <HostedAuth />
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

// https://www.npmjs.com/package/react-material-ui-carousel
export const getCarouselStyles = (theme: Theme): any => {
  return {
    indicatorContainerProps: {
      style: {
        marginTop: "64px",
      },
    },
    indicatorIconButtonProps: {
      style: {
        margin: "8px",
        color: "transparent",
        border: `solid 1px ${theme.palette.secondary.dark}`,
      },
    },
    activeIndicatorIconButtonProps: {
      style: {
        backgroundColor: `${theme.palette.secondary.dark}`,
      },
    },
  };
};
